import React from 'react';

import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { LazySuspense } from '@atlassian/react-loosely-lazy/suspense/component';

const LazyWidget = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-csm-support-widget" */ '@jira/customer-service__csm-widget/src/CsmSupportWidget.tsx'
		),
);

export const LazyCsmSupportWidget: React.FC = () => {
	return (
		<JSErrorBoundary
			id="csmSupportWidget"
			packageName="jiraCustomerServiceCsmSupportWidgetLayout"
			teamName="csm-ai-exp"
			fallback="unmount"
		>
			<LazySuspense fallback={null}>
				<LazyWidget />
			</LazySuspense>
		</JSErrorBoundary>
	);
};
